// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronUp as RawChevronUp } from "lucide-react";
export const ChevronUp = /* @__PURE__ */ createIcon(RawChevronUp, "ChevronUp", 2);
